var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFiledoneicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.182 16.418a6.447 6.447 0 110 12.894 6.447 6.447 0 010-12.894z",
    fill: "#bbca8e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.062 20.51l-4.819 4.669a.151.151 0 01-.209.001l-2.302-2.17",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.23
  })));
}

export default SvgFiledoneicon;